import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  paper: {
    marginTop: '100px',
    borderRadius: '15px',
    padding: '20px',
    boxShadow: `0 0 2px 2px rgb(0 0 0 / 0.2)`,
  },
  media: {
    borderRadius: '20px',
    objectFit: 'cover',
    width: '100%',
    maxHeight: '400px',
  },
  card: {
    display: 'flex',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      flexDirection: 'column',
    },
  },
  section: {
    borderRadius: '20px',
    margin: '10px',
    flex: 1,
  },
  avatar: {
    width: '50px',
    height: '50px',
  },
  createdBy: {
    display: 'flex',
    margin: '10px auto',
  },

  userName: {
    display: 'flex',
    marginTop: '6px',
  },
  imageSection: {
    width: '50%',
    display: 'block',
    marginLeft: '20px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      width: '100%',
    },
  },
  button: {
    backgroundColor: '#000',
    color: '#fff',
    borderRadius: '6px',
    margin: '5px auto',
    width: '100%',
    '&:hover': {
      background: 'linear-gradient(90deg, #92fe9d 0%, #00C9FF 100%)',
    },
  },
  buttonDelete: {
    margin: '5px auto',
    borderRadius: '10px',
    width: '10px',
    color: '#000',
  },
  buttonShare: {
    margin: '5px auto',
    borderRadius: '10px',
    width: '10px',
    color: '#000',
  },
  roomTime: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#787A91',
  },
  timeTitle: {
    fontWeight: 500,
    fontSize: '0.9rem',
  },
  timeTitleEnd: {
    fontWeight: 500,
    fontSize: '0.9rem',
  },
  dateRoom: {
    fontSize: '0.8rem',
    fontWeight: 500,
    color: '#000',
  },
  timeRoom: {
    fontSize: '1.17rem',
    fontWeight: 560,
    color: '#000',
  },
  recommendedPosts: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  loadingPaper: {
    display: 'flex',
    marginTop: '95px',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    borderRadius: '15px',
    height: '75vh',
  },
  categorynStatus: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  progressTime: {
    fontSize: '0.9rem',
    height: '25px',
    width: 'auto',
    padding: 3,
    fontWeight: 500,
    color: '#000',
    textAlign: 'center',
    background: 'linear-gradient(90deg, #92fe9d 0%, #00C9FF 100%)',
  },
}))
